/**
 * Nomes de eventos compartilhados com o backend.
 * Espelha `backend/realtime/channels.js` — mantenha os dois em sincronia.
 */
export const EVENT_TYPES = Object.freeze({
  PEDIDO_CRIADO: 'pedido.criado',
  PEDIDO_ATUALIZADO: 'pedido.atualizado',
  PEDIDO_STATUS_ALTERADO: 'pedido.status_alterado',
  PEDIDO_ARQUIVOS_LIBERADOS: 'pedido.arquivos_liberados',
  PEDIDO_VISUALIZADO: 'pedido.visualizado',
  PEDIDO_WHATSAPP: 'pedido.whatsapp',
  PAGAMENTO_ATUALIZADO: 'pagamento.atualizado',
  CLIENTE_CRIADO: 'cliente.criado',
  CLIENTE_ATUALIZADO: 'cliente.atualizado',
  CLIENTE_REMOVIDO: 'cliente.removido',
  PRESENCA_ALTERADA: 'presenca.alterada',
  NOTIFICACAO_NOVA: 'notificacao.nova',
  NOTIFICACAO_LIDA: 'notificacao.lida',
  NOTIFICACAO_ESTADO: 'notificacao.estado',
  NOTIFICACAO_REMOVIDA: 'notificacao.removida',
  ARQUIVO_UPLOAD_INICIADO: 'arquivo.upload_iniciado',
  ARQUIVO_UPLOAD_PROGRESSO: 'arquivo.upload_progresso',
  ARQUIVO_UPLOAD_CONCLUIDO: 'arquivo.upload_concluido',
  ARQUIVO_UPLOAD_FALHOU: 'arquivo.upload_falhou',
  ARQUIVO_CRIADO: 'arquivo.criado',
  ARQUIVO_REMOVIDO: 'arquivo.removido',
  ARQUIVO_VIDEO_STATUS: 'arquivo.video_status',
  ARQUIVO_BAIXADO_CLIENTE: 'arquivo.baixado_cliente',
  SELECAO_ITEM_ALTERADO: 'selecao.item_alterado',
  SELECAO_CONFIRMADA: 'selecao.confirmada',
  SELECAO_REABERTA: 'selecao.reaberta',
  SELECAO_PASTA_ATIVADA: 'selecao.pasta_ativada',
  SELECAO_PASTA_DESATIVADA: 'selecao.pasta_desativada',
});

export const LEGACY_EVENT_TYPES = Object.freeze({
  PEDIDO_UPDATED: 'pedido_updated',
  PEDIDO_RETIRADA_CHANGED: 'pedido_retirada_changed',
  FILES_RELEASED: 'files_released',
  PAYMENT_UPDATED: 'payment_updated',
  CLIENT_CREATED: 'client_created',
  CLIENT_UPDATED: 'client_updated',
  CLIENT_DELETED: 'client_deleted',
});

export const LEGACY_TO_CANONICAL = Object.freeze({
  [LEGACY_EVENT_TYPES.PEDIDO_UPDATED]: EVENT_TYPES.PEDIDO_ATUALIZADO,
  [LEGACY_EVENT_TYPES.PEDIDO_RETIRADA_CHANGED]: EVENT_TYPES.PEDIDO_ATUALIZADO,
  [LEGACY_EVENT_TYPES.FILES_RELEASED]: EVENT_TYPES.PEDIDO_ARQUIVOS_LIBERADOS,
  [LEGACY_EVENT_TYPES.PAYMENT_UPDATED]: EVENT_TYPES.PAGAMENTO_ATUALIZADO,
  [LEGACY_EVENT_TYPES.CLIENT_CREATED]: EVENT_TYPES.CLIENTE_CRIADO,
  [LEGACY_EVENT_TYPES.CLIENT_UPDATED]: EVENT_TYPES.CLIENTE_ATUALIZADO,
  [LEGACY_EVENT_TYPES.CLIENT_DELETED]: EVENT_TYPES.CLIENTE_REMOVIDO,
});

export const canonicalTypeFor = (eventName) => LEGACY_TO_CANONICAL[eventName] || eventName;
